import { AgentInfo } from "../../app/util/BrowserDetection";

export default class AgentInfoDto {

    browserName?: string;
    browserVersion?: string;

    plattformType?: string;
    osName?: string;
    osVersion?: string;

    constructor(agentInfo: AgentInfo) {
        this.browserName = agentInfo.browser.name;
        this.browserVersion = agentInfo.browser.version;
        this.plattformType = agentInfo.plattformType;
        this.osName = agentInfo.os.name;
        this.osVersion = agentInfo.os.version
    }
}